import {
  Stack,
  Typography,
  IconButton,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import {
  SaveDeliveryModal,
  SaveDecisionModal,
  SaveInstallationPlanModal
} from 'modules/components/layer17';

import React, {
  ReactNode,
  useState
} from 'react';

import { theme as projectTheme } from 'theme';



export type IInstallationItemType =
'DELIVERY' |
'DECISION' |
'PLAN' |
'ATTACHMENT';

type IProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};


type IBaseModalProps = (props: IProps) => JSX.Element;

const __installationItemType2Modal: Record<IInstallationItemType, IBaseModalProps> = {
  ATTACHMENT: (props: IProps) => <></>,
  DECISION: (props: IProps) => <SaveDecisionModal.FC {...props} />,
  PLAN: (props: IProps) => <SaveInstallationPlanModal.FC {...props} />,
  DELIVERY: (props: IProps) => <SaveDeliveryModal.FC {...props} />
};


export type IItemState = 'COMPLETE' | 'DUESOON' | 'OVERDUE' | 'REMAINING';

export type InstallationItemProps = {
  id: string;
  installationItemType: IInstallationItemType;
  title?: string;
  children?: ReactNode;
  itemState?: IItemState;
  disableEdit?: boolean;
  disableRemove?: boolean;
  handleRemove?: () => void;
};

const __itemComponent2Color: Record<IItemState, string> = {
  COMPLETE: projectTheme.palette.primary.light,
  REMAINING: projectTheme.palette.secondary.main,
  DUESOON: projectTheme.palette.warning.light,
  OVERDUE: projectTheme.palette.error.light
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationItemProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState<boolean>(false);
  const theme = useTheme();
  const fnShowModal = __installationItemType2Modal[props.installationItemType];



  return (
    <>
      {isVisible && (
        fnShowModal({
          id: props.id,
          isVisible: isVisible,
          handleClose: () => setIsVisible((prev) => !prev)
        })
      )}
      <Stack
        borderRadius='1rem'
        padding='1rem'
        rowGap='.75rem'
        bgcolor={__itemComponent2Color[props.itemState ?? 'REMAINING']}
      >
        <Stack
          direction='row'
          justifyContent='space-between'
        >

          <Typography
            variant='bodyBold'
            color={theme.palette.primary.main}
          >
            {props.title}
          </Typography>


          <Stack
            direction='row'
            columnGap='.5rem'
          >
            <IconButton
              disabled={props.disableRemove}
              onClick={() => props.handleRemove && props.handleRemove()}
              sx={{
                borderRadius: '.625rem',
                bgcolor: props.disableEdit ? theme.palette.grey[300] : theme.palette.error.main
              }}
            >
              <CustomIcon.large.FC
                icon='DELETE'
                stroke='white'
              />
            </IconButton>
            {!props.disableEdit && (

              <IconButton
                onClick={() => setIsVisible(() => true)}
                sx={{
                  borderRadius: '.625rem',
                  bgcolor: theme.palette.primary.main
                }}
              >
                <CustomIcon.large.FC
                  icon='EDIT'
                  stroke='white'
                />
              </IconButton>
            )}
          </Stack>

        </Stack>
        {props.children}
      </Stack>
    </>
  );
};
